var defaultLocale = {
    invalidate: 'invalidate time',
    yesterday: 'yesterday'
};
var TIME_UNIT_DAY = 24 * 60 * 60 * 1000;
function isThisYear(time) {
    var now = new Date();
    return time.getFullYear() === now.getFullYear();
}
function isToday(time) {
    var now = new Date();
    return time.getFullYear() === now.getFullYear()
        && time.getMonth() === now.getMonth()
        && time.getDate() === now.getDate();
}
function isYesterday(time) {
    var now = new Date();
    var s = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
    var t = time.getTime();
    return (t >= s - TIME_UNIT_DAY) && (t < s);
}
function pad(n) {
    var d1 = Math.floor(n / 10);
    var d0 = n % 10;
    return "" + d1 + d0;
}
function formatDate(time, displayYear) {
    if (displayYear === void 0) { displayYear = false; }
    var year = time.getFullYear();
    var month = time.getMonth() + 1;
    var date = time.getDate();
    var extra = (displayYear ? '/' + year : '');
    return pad(date) + "/" + pad(month) + extra;
}
function formatDatetime(time) {
    var hours = time.getHours();
    var minutes = time.getMinutes();
    return pad(hours) + ":" + pad(minutes);
}
var TextUtil = (function () {
    function TextUtil() {
    }
    TextUtil.getFriendlyDate = function (time, options) {
        if (options === void 0) { options = {}; }
        var _a = options.locale, locale = _a === void 0 ? defaultLocale : _a, _b = options.displayTime, displayTime = _b === void 0 ? false : _b;
        if (time < 0) {
            return '';
        }
        var date = new Date(time);
        if (isToday(date)) {
            return formatDatetime(date);
        }
        var extra = (displayTime ? ' ' + formatDatetime(date) : '');
        if (isYesterday(date)) {
            return "" + locale.yesterday + extra;
        }
        if (isThisYear(date)) {
            return "" + formatDate(date) + extra;
        }
        return "" + formatDate(date, true) + extra;
    };
    TextUtil.maxNumberStr = function (number, max) {
        if (max === void 0) { max = 99; }
        return number > max ? max + "+" : "" + number;
    };
    return TextUtil;
}());
export default TextUtil;

//# sourceMappingURL=text.js.map
